// extracted by mini-css-extract-plugin
module.exports = {"el":"BtnFullscreen_el__1L9tE"};